/* eslint-disable no-magic-numbers */
// import blowfish from "@sighmir/blowfish";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * STATES
 */
export var STATES;
(function (STATES) {
    STATES[STATES["SUCCESS"] = 200] = "SUCCESS";
    STATES[STATES["INIT"] = 202] = "INIT";
    STATES[STATES["FAILURE"] = 400] = "FAILURE";
    STATES[STATES["ERROR"] = 500] = "ERROR";
})(STATES || (STATES = {}));
/**
 * URLS
 */
var URLS;
(function (URLS) {
    URLS["HOST"] = "https://as.photoprintit.com/web/email";
    URLS["SIGNIN"] = "/signin.rest";
    URLS["SIGNOUT"] = "/signout.rest";
    URLS["CONFIRM"] = "/confirm.rest";
})(URLS || (URLS = {}));
/* UtilNewsletterApi util */
class UtilNewsletterApi {
    /**
     * @docs
     * @method constructor - create a new instance of UtilNewsletterApi
     * @param {object} options
     */
    constructor(options = {}) {
        /**
         *
         * @private
         */
        this.options = {
            endpointUrl: URLS.HOST,
        };
        Object.assign(this.options, options);
    }
    /**
     * @docs
     * @method signIn - signIn to ops newsletter api
     *
     * @param {object} properties
     *
     * @returns {string}
     */
    signIn(properties) {
        return __awaiter(this, void 0, void 0, function* () {
            let result;
            try {
                const _response = yield fetch(this._getUrl(URLS.SIGNIN, this._prepareProperties(properties)), {
                    method: 'GET',
                });
                result = this._prepareResult(_response.status);
            }
            catch (error) {
                result = this._prepareResult(STATES.ERROR);
                console.error(error);
            }
            return new Promise((resolve) => {
                setTimeout(() => resolve(result), 2500);
            });
        });
    }
    /**
     * @docs
     * @method signIn - returns a useless string
     *
     * @param {UtilNewsletterApiRequestSignIn} object
     *
     * @returns {string}
     */
    signOut(object) {
        return __awaiter(this, void 0, void 0, function* () {
            let result;
            try {
                const _response = yield fetch(this._getUrl(URLS.SIGNOUT, {
                    nlid: this._createNlId(object),
                }), {
                    method: 'GET',
                });
                result = this._prepareResult(_response.status);
            }
            catch (error) {
                result = this._prepareResult(STATES.ERROR);
                console.error(error);
            }
            return result;
        });
    }
    /**
     * @docs
     * @method confirm - confirm a newsletter signup
     *
     * @param {UtilNewsletterApiRequestConfirm} object
     *
     * @returns {string}
     */
    confirm(object) {
        return __awaiter(this, void 0, void 0, function* () {
            let result;
            try {
                const _response = yield fetch(this._getUrl(URLS.CONFIRM, object), {
                    method: 'GET',
                });
                result = this._prepareResult(_response.status);
            }
            catch (error) {
                result = this._prepareResult(STATES.ERROR);
                console.error(error);
            }
            return result;
        });
    }
    /**
     * _prepareResult
     * @param {number} state
     *
     * @returns {UtilNewsletterApiResult}
     */
    _prepareResult(state) {
        return {
            state: state || STATES.ERROR,
            message: UtilNewsletterApi.MESSAGES[state] || UtilNewsletterApi.MESSAGES[STATES.ERROR],
        };
    }
    /**
     * _prepareProperties
     * @param {object} properties
     *
     * @returns {object}
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _prepareProperties(properties) {
        /* in async environment we need to set this to false */
        properties.redirect = false;
        return properties;
    }
    /**
     * _getUrl
     * @param {string} url
     * @param [params]
     *
     * @returns {string}
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _getUrl(url, params) {
        let _url = this.options.endpointUrl + url;
        if (params) {
            _url += '?' + new URLSearchParams(params);
        }
        return _url;
    }
    /**
     * _createNlId
     * @param {UtilNewsletterApiRequestSignOut} object
     *
     * @return {string}
     */
    _createNlId(object) {
        // @TODO: Blowfish encrypted and Base64 and encoded JSON string according to URL guidelines (*)
        return JSON.stringify(object);
    }
}
/**
 * MESSAGES
 */
UtilNewsletterApi.MESSAGES = {
    200: 'everything ok',
    202: 'opt-in email send',
    400: 'signup failed',
    500: 'unknown error',
};
export default UtilNewsletterApi;
